module.exports = __webpack_public_path__ + "images/pro/icon-pro-features-20f319254803a5c8e8aa7e28ba6d6681.png";